/**
 * Created by intellicar-rinas on 9/8/17.
 */
import $http from "../helpers/$http";
import { API_HOST } from "../constants/constants";
import apiHelper from "../helpers/apiHelper";

const GroupsAPIs = {
  getList: (body, uid) => {
    return $http
      .post(API_HOST + "/api/group/list", body, {}, uid)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getEVGroups: (body, uid) => {
    return $http
      .post(API_HOST + "/api/group/listevgroups", body, {}, uid)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
};

export default GroupsAPIs;
